// removed by extract-text-webpack-plugin
module.exports = {"key":"Key__key___2jZu1","mod":"Key__mod___3-MCD","mod--symbol":"Key__mod--symbol___3IakT","key--alpha":"Key__key--alpha___1tPl0 Key__key___2jZu1","key--modifier":"Key__key--modifier___L8ZVj Key__key___2jZu1","key--numberRow":"Key__key--numberRow___pP8mv Key__key___2jZu1","key--esc":"Key__key--esc___CBG_1 Key__key___2jZu1","key--layer":"Key__key--layer___RFINc Key__key___2jZu1","key--delete":"Key__key--delete___1b_AS Key__key___2jZu1","key--enter":"Key__key--enter___2KMFo Key__key___2jZu1","key--space":"Key__key--space___2G1rT Key__key___2jZu1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Key/Key.scss
// module id = 101
// module chunks = 0